export const translations = {
    "locations": [
      "Location",      
      "位置",
      "Location"
    ],
    "search": [
      "Direction",    
      "路線",
      "Direction"   
    ],
    "mylocation": [
      "My Location",    
      "我的位置",
      "My Location"   
    ],
    "changeLanguage": [
        "Language",    
        "語言",
        "Language"   
    ],
    "umCampus": [
      "UM Campus",    
      "澳大校園",
      "UM Campus"   
    ],    
    "traditionalChinese": [
        "Chinese",    
        "中文",
        "Chinese"   
    ],
    "English": [
      "English",    
      "英文",
      "English"   
    ],
    "Portugues": [
      "Portugues",    
      "葡語",
      "Português"   
    ]
  };